import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import _toConsumableArray from "E:\\workspace\\\u6C9B\u57CE\\pcweb\\node_modules\\@babel\\runtime/helpers/esm/toConsumableArray";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import config from "@/config";
import { pests } from "@/api/api_url";
import { renderFormMixins } from "@/mixins/renderFormMixins";
import { get_type, catch_fear_timelist, deviceinfo_list } from "@/api/jingxiaoshang"; //import commonTitle from '@/view/console/components/commonTitle'

export default {
  name: "addAppCustom",
  mixins: [renderFormMixins],
  data: function data() {
    return {
      tableloading: false,
      modelcodeData: [],
      //数据
      product_type_codeData: [],
      path: [],
      reqBase: {},
      formModel: {
        //  model_code:null,
        protocol_type: null,
        protocol_number: null,
        protocol_name: null,
        inverter_type: null
      },
      spinShow: false,
      formRules: {
        product_type_code: [{
          required: true,
          type: "string",
          message: this._vm.$t('产品名称不能为空'),
          trigger: "change"
        }],
        xieyi_name: [{
          required: true,
          message: this._vm.$t('协议列表中文名称不能为空'),
          trigger: "change"
        }],
        xieyi_name_en: [{
          required: true,
          message: this._vm.$t('协议列表英文名称不能为空'),
          trigger: "change"
        }]
      },
      nodeList: [],
      tempData: {} //等待提交的临时数据

    };
  },
  props: {
    _vm: {},
    edit: {
      type: Boolean,
      default: false
    },
    hasDetails: {
      type: Boolean,
      default: false
    },
    $store: {},
    setData: {},
    product_type_codeData: {},
    parent_code: {},
    parent_name: {}
  },
  components: {},
  computed: {
    getAction: function getAction() {
      var result = "";

      if (process.env.NODE_ENV === "development") {
        result = config.baseUrl.dev + "" + pests.upload_file;
      } else if (process.env.VUE_APP_BUILD === "production") {
        result = config.baseUrl.pro + "" + pests.upload_file;
      } else {
        result = config.baseUrl.alp + "" + pests.upload_file;
      }

      return result;
    },
    projectCode: function projectCode() {
      return this.$store.state.user.projectCode;
    }
  },
  methods: {
    /**
     * 单个删除
     */
    delDevice: function delDevice(row) {
      for (var i = 0; i < this.data2.length; i++) {
        var list = this.data2[i];

        if (row.device_id === list.device_id) {
          //同时删除临时对象中的数据
          var index = this.tempData[list.node_code].indexOf(list.device_id);

          if (index > -1) {
            this.tempData[list.node_code].splice(index, 1);
          }

          this.data2.splice(i, 1);
          break;
        }
      }
    },
    clickNode: function clickNode(data) {
      var _this = this;

      this.data1.splice(0);
      this.tableloading = true;
      this.$set(this.reqBase, "page", 1);
      this.$set(this.reqBase, "page_size", 2000);
      this.$set(this.reqBase, "node_code", data.node_code);
      this.$set(this.reqBase, "project_code", this.projectCode);
      deviceinfo_list(this.reqBase).then(function (res) {
        _this.tableloading = false;

        if (res.result === 0) {
          var _this$data;

          var list = res.body.list || [];

          (_this$data = _this.data1).push.apply(_this$data, _toConsumableArray(list));
        } else {}
      });
    },
    addTimeFun: function addTimeFun() {
      this.$refs.addTime.showModal(true);
    },
    createTree: function createTree(data) {
      for (var i in data) {
        var list = data[i];
        list["value"] = list.cate_code;
        list["label"] = list.cate_name;

        if (list.children && list.children.length > 0) {
          this.createTree(list.children);
        }
      }
    },
    getTreeNodeData: function getTreeNodeData(callback) {
      var _this2 = this;

      this.spinShow = true;
      this.nodeList.splice(0);
      patrolcateGetAllCate({
        project_code: this._vm.$store.state.user.projectCode
      }).then(function (res) {
        _this2.spinShow = false;

        if (res.result === 0) {
          var _this2$nodeList;

          var data = res.body;

          _this2.createTree(data);

          (_this2$nodeList = _this2.nodeList).push.apply(_this2$nodeList, _toConsumableArray(data));

          if (callback) {
            callback(_this2.nodeList);
          }
        } else {}
      });
    },
    init: function init() {},

    /**
     * 获取节点所在数组的位置
     */
    getTreeNodeArray: function getTreeNodeArray(tree, func, path) {
      if (!tree) return [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = tree[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var data = _step.value;
          // 这里按照你的需求来存放最后返回的内容吧
          //这里的date是表示我是根据date去查询父级的，你可以修改成你的需求，其他不变
          path.push(data.node_code);
          if (func(data)) return path;

          if (data.children) {
            var findChildren = this.getTreeNodeArray(data.children, func, path);
            if (findChildren.length) return findChildren;
          }

          path.pop();
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return [];
    },

    /**
     * 返回数据
     */
    setTimeRule: function setTimeRule(timeObj) {
      this.$set(this.formModel.plan_interval, "plan_start", timeObj.plan_start);
      this.$set(this.formModel.plan_interval, "plan_end", timeObj.plan_end);
      this.$set(this.formModel.plan_interval, "interval", timeObj.interval);
      this.$set(this.formModel, "plan_accuracy", timeObj.plan_accuracy);
    }
  },
  mounted: function mounted() {
    // this.get_type();
    console.log("ccc", this.setData);

    if (this.edit) {
      console.log("bbb", this.setData);

      if (this.setData) {
        console.log("aaa", this.setData); //   //debugger
        //   this.codeData.push({
        //     value:this.setData.parent_code,
        //     label:this.setData.parent_name
        //   })

        Object.assign(this.formModel, this.setData); //this.$set(this.formModel,'protocol_type',this.setData.protocol_type_value)

        console.log(this.formModel);
      }
    } else {//this.$set(this.formModel,'model_codes',this.parent_code)
    }
  },
  created: function created() {// this.init()
  }
};